const ApiPreloadImages = {
    'body':'',
    'images': [
        'img-hero.avif',
        'bg-structure.avif',
        'img-business-model.avif',
        'img-bridge.avif',
        'img-about-us.avif',
        'img-bridge-v2.avif',
        'img-industries.avif',
        'img-process.avif',
        'img-management.avif',
        'bg-about-us.avif',
        'bg-history.avif',
        'bg-history-line-0.avif',
        'bg-history-line-1.avif',
        'bg-history-line-2.avif',
        'bg-business-model.avif',
        'bg-fee-structure.avif',
    ],
    'start':function(){
        let self = this;
        self.init();
        self.setPreloadImages();
    },
    'setPreloadImages': function(){
        let self = this;

        let head = document.head;

        self.images.forEach(src => {
            // console.log('-> preload: '+src);
            let link = document.createElement('link');
            link.rel = 'preload';
            link.as = 'image';
            link.href = _image + src;
            link.fetchPriority = 'high';
            head.appendChild(link);
        });
    },
    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    // ApiPreloadImages.start();
});
